import { render } from "./rdr-records.vue?vue&type=template&id=ca059756&scoped=true"
import script from "./rdr-records.vue?vue&type=script&lang=js"
export * from "./rdr-records.vue?vue&type=script&lang=js"

import "./rdr-records.vue?vue&type=style&index=0&id=ca059756&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca059756"]])

export default __exports__